<template>
  <div id="contactResults">
    <template v-if="contactResultItems.length">
      <div v-for="(item, i) of contactResultItems" :key="i">
        <h4><span v-html="getCarrierNameByID(item.carrier)"></span></h4>
        <b-list-group>
          <b-list-group-item v-for="(contact, i) of item.contacts"  :key="i" :href="contact.url" target="_blank"><span v-html="contact.name"></span></b-list-group-item>
        </b-list-group>
      </div>
    </template>
  </div>
</template>

<script>
import {bus} from "@/event-bus"
import HelperFunctions from "@/mixins/helper-functions"
export default {
  name: "contactResults",
  mixins: [HelperFunctions],
  data: () => ({
    contactResultItems: [],
  }),
  mounted() {
    bus.$on("update-contact-results-items", items => {
      this.contactResultItems = []
      this.contactResultItems = items
    })
    bus.$on("update-carriers", carriers => {
      this.carriers = []
      this.carriers = carriers
    })
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
